import { render, staticRenderFns } from "./CounterReturns.vue?vue&type=template&id=7b5319bc&scoped=true"
import script from "./CounterReturns.vue?vue&type=script&lang=js"
export * from "./CounterReturns.vue?vue&type=script&lang=js"
import style0 from "./CounterReturns.vue?vue&type=style&index=0&id=7b5319bc&prod&scoped=true&lang=css"
import style1 from "./CounterReturns.vue?vue&type=style&index=1&id=7b5319bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5319bc",
  null
  
)

export default component.exports